export enum VidMuseEvent {
  // Custom Events
  DomainProbeFailed = "domain_probe_failed",

  // Page Events
  HomePageDisplayed = "home_page_displayed",
  ThreadListPageDisplayed = "thread_list_page_displayed",
  ThreadDetailPageDisplayed = "thread_detail_page_displayed",
  LoginPageDisplayed = "login_page_displayed",
  ThreadSharePageDisplayed = "thread_share_page_displayed",
  PricingPageDisplayed = "pricing_page_displayed",

  // Home Page
  HomePageCreateThread = "home_create_thread",
  KnowledgeBaseSelected = "knowledge_base_selected",

  // Thread Page
  ThreadPageTryForFreeBtnClick = "thread_page_try_for_free_btn_click",
  ThreadPageRestoreCheckpoint = "thread_page_restore_checkpoint",

  // Thread Events
  ThreadSendMessage = "thread_send_message",
  ThreadContinue = "thread_continue",

  // Artifacts
  ArtifactResultVideoDisplay = "artifact_result_video_display",
  ArtifactResultVideoClick = "artifact_result_video_click",
  ArtifactResultVideoDownload = "artifact_result_video_download",
  ArtifactProjectDownload = "artifact_project_download",
  ArtifactSharePopoverOpened = "artifact_share_popover_opened",
  ArtifactShareSocialBtnClick = "artifact_share_social_btn_click",
  ArtifactShareCopyBtnClick = "artifact_share_copy_btn_click",
  ArtifactSectionDisplayed = "artifact_section_displayed",

  // Share Page
  ThreadSharePageRemix = "thread_share_page_remix",
  ThreadSharePageOpenProject = "thread_share_page_open_project",
  ThreadSharePageShareSocialBtnClick = "thread_share_page_share_social_btn_click",
  ThreadSharePageCopyLinkBtnClick = "thread_share_page_copy_link_btn_click",

  // Media Editor Modal Events
  MediaEditorModalOpened = "media_editor_modal_opened",
  MediaEditorModalGenerateBtn = "media_editor_modal_generate_click",
  MediaEditorModalReplaceBtn = "media_editor_modal_replace_click",
  MediaEditorModalRemixBtn = "media_editor_modal_remix_click",
  MediaEditorModalSelectVersionBtn = "media_editor_modal_select_version_click",
  MediaEditorModalDownloadBtn = "media_editor_modal_download_click",

  // Pricing Page
  PricingPagePlanClick = "pricing_page_plan_click",
  PricingPageCreditPackageClick = "pricing_page_credit_package_click",
  PricingPageRedeemCodeClick = "pricing_page_redeem_code_click",

  // Redeem Code Modal
  RedeemCodeModalSureClick = "redeem_code_modal_sure_click",

  // Invite Campaign
  InviteButtonClick = "invite_button_click",
  InviteGuideModalDisplayed = "invite_guide_modal_displayed",
  InviteGuideModalCopyLinkBtnClick = "invite_guide_modal_copy_link_btn_click",

  // Studio Events
  StudioDisplayed = "studio_displayed",
  StudioExportFinalVideoClick = "studio_export_final_video_click",
  StudioExportEntireProjectClick = "studio_export_entire_project_click",

  // First Purchase Promo
  FirstPurchasePromoDialogDisplayed = "first_purchase_promo_dialog_displayed",
  FirstPurchasePromoDialogClaimClick = "first_purchase_promo_dialog_claim_click",
  FreeUserClickCustomModel = "free_user_click_custom_model",
  FreeUserClickResolutionHD = "free_user_click_resolution_hd",
  FreeUserClickRemoveWatermark = "free_user_click_remove_watermark",
  FreeUserNoCreditClickManuallyGenerate = "free_user_no_credit_click_manually_generate",
  FreeUserStayPricingPageFor30s = "free_user_stay_pricing_page_for_30s",
  FreeUserStayPricingPageFor100s = "free_user_stay_pricing_page_for_100s",

  // Trial & AddOns Modal
  FreeUserTrialModalDisplayed = "free_user_trial_modal_displayed",
  FreeUserTrialModalClaimClick = "free_user_trial_modal_claim_click",
  FreeUserTrialModalRulesClick = "free_user_trial_modal_rules_click",
  PaidUserAddOnsModalDisplayed = "paid_user_add_ons_modal_displayed",
  PaidUserAddOnsModalClaimClick = "paid_user_add_ons_modal_claim_click",

  // Google Events, 需要在 logger.ts 中配置转发
  Purchase = "purchase",
  NewUserJoin = "new_user_join",
  HeaderMenuClick = "header_menu_click",
}
